export default {"src":"/_next/static/media/navbar-get-started.e695b23d.svg","height":64,"width":177};